import { Component, HostListener, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, NavigationEnd } from '@angular/router';
import { MessagingService } from './components/shared/services/messaging.service';
import { SharedMethods } from './components/shared/services/sharedMethods-service';
import swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { CartService } from './components/shared/services/cart.service';
import { MatomoInjector } from '@codeculture/ngx-matomo';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Bessalel Store';

  // declare let ga: Function;

  message;

  // tslint:disable-next-line:max-line-length
  constructor(private matomoInjector: MatomoInjector, private messagingService: MessagingService, private cartService: CartService, private router: Router, private spinner: NgxSpinnerService, private sharedMethods: SharedMethods, private dialog: MatDialog,) {

    // Recuparation de lévénement de changement de route pour google analytic
    /* this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (window as any).ga('set', 'page',  event.urlAfterRedirects);
        (window as any).ga('send', 'pageview');
      }
    }); */

    // fire base
    // this.messagingService.requestPermission()
    // this.messagingService.receiveMessage()
    // this.message = this.messagingService.currentMessage

  }


  ngOnInit() {

    this.matomoInjector.init('https://analytic.optimumdigital.academy', [1]);

    /** spinner starts on init */
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      // this.spinner.hide();
    }, 5000);

    this.sharedMethods.dataloading().subscribe(data => {

      console.log('dataloading', data);

      // localStorage.setItem('dataloading', JSON.stringify(data));
      this.sharedMethods.cacheLoading = data;

      this.spinner.hide();

    }, err => {

      this.spinner.hide();

      swal({
        title: 'Echec chargement',
        html: 'Vérifiez votre connexion et cliquez sur ok pour recharger !',
        // icon: 'warning',
        type: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        // cancelButtonText: 'cancel',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {

        if (result.value) {

          // this.sharedMethods.sweetalert('success', 'Retour supprimé', '');
          this.ngOnInit();

        }

        // this.dialogIsNotShow = false;

      });
    });

  }


  @HostListener('window:message', ['$event'])
  onMessage(e) {

    // tslint:disable-next-line:no-debugger
    // debugger;
    /* if (e.origin !== 'http://localhost:4200') { // set your origin
      return false;
    } */

    // if (e.data === 'PAYMENT_SUCCESS' && e.origin !== window.location.href) {
    if (e.data === 'PAYMENT_SUCCESS') {
      console.log(e.data);
      // alert(e.data);

      this.dialog.closeAll()


      swal({
        title: 'Paiment réussi',
        html: 'Votre paiement a été effectué avec success; vous serez redirigé vers la page de téléchargment pour accéder à vos ressources',
        // icon: 'warning',
        type: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        // cancelButtonText: 'cancel',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {

          if (result.value) {

            // this.sharedMethods.sweetalert('success', 'Retour supprimé', '');
            // this.ngOnInit();

            this.cartService.clean();

            this.router.navigate(['/pages/downloads']);

          }

          // this.dialogIsNotShow = false;

      });
      
    }


    if (e.data === 'PAYMENT_CANCEL') {
      console.log(e.data);
      // alert(e.data);

      this.dialog.closeAll()


      swal({
        title: 'Annulation Paiment',
        html: 'Votre paiement a été annuler.',
        // icon: 'warning',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#d33',
        // cancelButtonText: 'cancel',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {

          if (result.value) {

            // this.sharedMethods.sweetalert('success', 'Retour supprimé', '');
            // this.ngOnInit();

            // this.router.navigate(['/pages/downloads']);

          }

          // this.dialogIsNotShow = false;

      });
      
    }


  }


  generateWhatsappLink(): string {
  
      // tslint:disable-next-line:max-line-length
      let tel = (this.sharedMethods.cacheLoading) ? this.sharedMethods.cacheLoading.settings.whatsapplinkcontact:'';
      if(tel && tel !== '')
      return 'https://api.whatsapp.com/send?phone=' + tel + '&text=*Optimum Digital* j\'ai besoin de votre assistance';
      else
      return '';
  }


}
